import Vue from 'vue'

export async function saveTrackingEvents ({ commit }, events) {
  try {
    await Vue.axios({
      method: 'POST',
      url: '/v1/trackers?tracking_event_type=facebook-pixel',
      data: events
    })
  } catch (error) {
    console.error(error)
  }
}
